export default class AppLogger {
  constructor(appUrl) {
    this.appUrl = appUrl;
  }

  log(data) {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", this.findLogEndpoint(), true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.send(JSON.stringify({ data, tag: "frames-v2-app" }));
  }

  findLogEndpoint = () => {
    return `${this.appUrl}/log`;
  };
}
